<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic :title="reportTitle" v-if="reportTitle" />
    </template>

    <div class="grid-report">
      <gc-filter-split-view
        :showLeftContainer="showFilterLeftContainer"
        :showRightContainer="showFilterRightContainer"
      >
        <template #leftContent>
          <dx-data-grid
            :data-source="dataSourceConfig"
            :allow-column-reordering="true"
            :reshape-on-push="true"
            :columns="columns"
            @toolbar-preparing="onToolbarPreparing($event)"
            :height="gridHeight"
            v-if="loadingCompleted"
            @content-ready="listContentReady"
            ref="grid-report-grid"
            @exporting="onGridToExcelExporting($event, saveFileName)"
            @cellPrepared="onCellPrepared($event, columnSummary)"
          >
            <DxExport :enabled="true" />
            <DxGroupPanel :visible="true" />
            <DxGrouping :auto-expand-all="true" />

            <DxSummary v-if="columnSummary">
              <!-- <DxGroupItem
                v-for="item in columnSummary"
                :key="item['id']"
                :column="item['column']"
                :summary-type="item['summary-type']"
                :value-format="item['value-format']"
                :display-format="item['display-format']"
                :show-in-group-footer="item['show-in-group-footer']"
                :align-by-column="item['align-by-column']"
                :show-in-column="item['show-in-column']"
              /> -->
              <DxTotalItem
                v-for="item in columnSummary"
                :key="item['id']"
                :column="item['show-in-column']"
                :summary-type="item['summary-type']"
                :value-format="item['value-format']"
                :display-format="item['display-format']"
                :show-in-column="item['show-in-column']"
              />
            </DxSummary>

            <template #customer-group-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerGroupName"
                :code="data.data.CustomerGroupCode"
              />
            </template>

            <template #customer-type-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerTypeName"
                :code="data.data.CustomerTypeCode"
              />
            </template>

            <template #customer-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerName"
                :code="data.data.CustomerCode"
              />
            </template>

            <template #branch-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.BranchName"
                :code="data.data.BranchCode"
              />
            </template>

            <!-- <template #category-1-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductCategory1Description"
                :code="data.data.ProductCategory1Code"
              />
            </template> -->

            <!-- <template #category-2-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductCategory2Description"
                :code="data.data.ProductCategory2Code"
              />
            </template> -->

            <!-- <template #category-3-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductCategory3Description"
                :code="data.data.ProductCategory3Code"
              />
            </template> -->

            <!-- <template #category-4-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductCategory4Description"
                :code="data.data.ProductCategory4Code"
              />
            </template> -->

            <template #sales-rep-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.OrderSalesRepName"
                :code="data.data.OrderSalesRepCode"
              />
            </template>

            <template #customer-rep-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerSalesRepName"
                :code="data.data.CustomerSalesRepCode"
              />
            </template>

            <template #item-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ItemName1"
                :code="data.data.ItemCode"
              />
            </template>

            <template #product-type-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProdTypeCode"
                :code="data.data.ProdTypeName"
              />
            </template>

            <!-- <template #product-size-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductSizeDescription"
                :code="data.data.ProductSizeCode"
              />
            </template> -->

            <!-- <template #groupHeaderTemplate="{ data }">
              <div class="informer">
                <span>{{ data.displayValue }}</span>
              </div>
            </template> -->

            <!-- <template #group-dategroupdisplay-cell-template="{ data }">
              <div class="informer">
                <span>{{ formatGroupDateGroupDisplay(data) }}</span>
              </div>
            </template> -->

            <!-- <template #dategroupdisplay-cell-template="{ data }">
              <div>
                <span>{{
                  formatDateGroupDisplay(data.data.DateGroupDisplay)
                }}</span>
              </div>
            </template> -->

            <template #number-cell-template="{ data }">
              <gc-grid-value-format :dataValue="data" />
            </template>
            <template #status-cell-template="{ data }">
              <gc-status-chip :status="data.data.OrderStatus" />
            </template>

            <template #division-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.DivisionName"
                :code="data.data.DivisionCode"
              />
            </template>

            <template #product-category-1-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProdCat1Name"
                :code="data.data.ProdCat1Code"
              />
            </template>
            <template #product-category-2-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProdCat2Name"
                :code="data.data.ProdCat2Code"
              />
            </template>
            <template #product-category-3-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProdCat3Name"
                :code="data.data.ProdCat3Code"
              />
            </template>
            <template #product-category-4-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProdCat4Name"
                :code="data.data.ProdCat4Code"
              />
            </template>

            <template #drop-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.DropName"
                :code="data.data.DropCode"
              />
            </template>
          </dx-data-grid>
        </template>

        <template #rightContent>

          <gc-advance-filter-panel
            :toolbar="filterToolbar"
            :setFilterFormHeight="filterFormHeight"
            :advanceFilterArray="advanceFilterArray"
            :filterCallBack="createFilterArray"
            :sideBarTabs="sideBarTabs"
            :filterFormItems="filterFormItems"
            :filterModel="getAdvanceFilterModel"
            :isJson="false"
            :screenType="'sales-order-details-report'"
            :applyFilter="applyFilter"
            :dirty.sync="filterDirty"
            :initial-filter="initialFilter"
            :dateRangeModel="dateRangeModel"
          >
          </gc-advance-filter-panel>
        </template>
      </gc-filter-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { GridReportService } from "../../_services/api/reports/grid-report.service";
import {
  DxSummary,
  DxTotalItem,
  DxExport,
  DxGrouping,
  DxGroupPanel,
} from "devextreme-vue/data-grid";

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: {
    DxExport,
    DxGrouping,
    DxSummary,
    DxTotalItem,
    DxGroupPanel,
  },
  data() {
    return {
      advanceFilterArray: [],
      serverSideFilter: [],
      jsonData: undefined,
      jSonDataItems: undefined,
      reportTitle: "Sales Order Detail",
      dataSourceConfig: [],
      showLeftContainer: true,
      showRightContainer: false,
      filterDirty: { isDirty: false },
      saveFileName: "Invoiced Sales",
      filterByDate: false,
      apiRouteUrl: {
        url: "api/ReportOutstandingSalesOrderDetail",
        filter: [["DateGroup", "=", "Day"]],
        // top: 50
      },
      loaded: false,
      //   columnSummary: undefined,
      advanceFilterModel: {
        DateGroup: "Day",
        DateIn: undefined,
        // WeekStartDate: undefined,
        // FiscalPeriodId: undefined,
        SalesRepresentativeCode: [],
        CustomerSalesRepresentativeCode: [],
        BranchCode: [],
      },
      model: {
        StartWeekDisplay: undefined,
        CurrentDateGroup: undefined,
        DefaultBranchCode: undefined,
      },
      applyServerFilter: true,
      dateRangeModel: {
        DateIn: "=",
        DateInTo: undefined,
        RequiredDate: "=",
        RequiredDateTo: undefined,
        ShipDate: "=",
        ShipDateTo: undefined
      }
    };
  },
  async created() {
    await this.$store.dispatch("screenFactors/getFactors", [
        65
      ]);

    this.model.DefaultBranchCode = this.getFactorByCode(65).Factorc;
    this.advanceFilterModel.BranchCode.push(this.model.DefaultBranchCode);
    // this.getCompanyDefaults();
    // this.showLoading(true);
    // await this.getDefaultValue();
    this.getReportData([]);
    // this.loadingCompleted = true;
  },
  methods: {
    async getDefaultValue() {
      this.advanceFilterModel.DateGroup = "Day";
      this.model.CurrentDateGroup = "Day";
      this.advanceFilterModel.DateIn = new Date();
      await GridReportService.requestData({
        url: "api/ReportCalendar",
        filter: "IsCurrentWeek eq true",
      })
        .then((result) => {
          this.advanceFilterModel.WeekStartDate = result.data.value[0].Code;
          this.model.StartWeekDisplay = result.data.value[0].StartWeek;
        })
        .catch((error) => {
          this.$logger.debug("api/ReportCalendar Error ", error);
        });

      await GridReportService.requestData({
        url: "api/ReportFiscalPeriod",
        filter: "IsCurrentFiscalPeriod eq true",
      })
        .then((result) => {
          this.advanceFilterModel.FiscalPeriodId =
            result.data.value[0].ThisFiscalPeriodId;
          this.advanceFilterModel.QuarterId = result.data.value[0].QuarterId;
        })
        .catch((error) => {
          this.$logger.debug("api/ReportFiscalPeriod Error ", error);
        });

      await GridReportService.requestData({
        url: "api/ReportFiscalYear",
        filter: "IsCurrentYear eq true",
      })
        .then((result) => {
          this.advanceFilterModel.Year = result.data.value[0].Year;
          this.advanceFilterModel.FiscalYear = result.data.value[0].FiscalYear;
        })
        .catch((error) => {
          this.$logger.debug("api/ReportFiscalYear Error ", error);
        });

      this.advanceFilterArray = [];
      await this.setDateFilter(new Date(), "DateIn");
      // await this.setWeekFilter();
      // await this.setMonthFilter(this.advanceFilterModel.FiscalPeriodId);
    },

    async getReportData(filterCollection) {
      let ds = GridReportService.dataSourceConfig(this.apiRouteUrl["url"], {
        count: true,
        preventPagination: true,
        top: 5,
        filter: this.initialFilter,
      });
      if (this.applyServerFilter) {
        // this.loadingCompleted = false;
        await ds.load();
        this.dataSourceConfig = ds.items();
        this.applyServerFilter = false;
      }

      if (this.$refs["grid-report-grid"]) {
        let grid = this.$refs["grid-report-grid"].instance;
        if (filterCollection.length != 0) {
          grid.filter(filterCollection);
          grid.refresh(true);
        } else {
          grid.clearFilter();
          grid.refresh(true);
        }
      }
      this.showLoading(false);
      this.loadingCompleted = true;

      this.model.CurrentDateGroup = this.advanceFilterModel.DateGroup;
    },
    listContentReady(e) {
      this.addGridNoResults(e);
    },
    async createFilterArray(filterCollection, filterField, e) {
      this.$logger.debug("createFilterArray ", filterCollection, filterField, e);
      // if (filterField == "DateGroup") {
      //   if (e.value == "Day") {
      //     await this.setDateFilter(this.advanceFilterModel.DateIn, "DateIn");
      //   } else if (e.value == "Week") {
      //     this.setWeekFilter();
      //   } else if (e.value == "Month") {
      //     await this.setMonthFilter(this.advanceFilterModel.FiscalPeriodId);
      //   } else if (e.value == "Quarter") {
      //     await this.setQuarterFilter(this.advanceFilterModel.QuarterId);
      //   } else if (e.value == "Calendar Year") {
      //     await this.setYearFilter(this.advanceFilterModel.Year, "Year");
      //   } else if (e.value == "Fiscal Year") {
      //     await this.setYearFilter(
      //       this.advanceFilterModel.FiscalYear,
      //       "FiscalYear"
      //     );
      //   }
      //   this.applyServerFilter = true;
      // }

      // if (filterField == "DateIn") {
      //   this.applyServerFilter = true;
      //   await this.setDateFilter(e.value, "DateIn");
      // } else if (filterField == "WeekStartDate") {
      //   this.applyServerFilter = true;
      //   // this.setWeekFilter();
      // } else if (filterField == "FiscalPeriodId") {
      //   this.applyServerFilter = true;
      //   await this.setMonthFilter(e.value);
      // } else if (filterField == "QuarterId") {
      //   this.applyServerFilter = true;
      //   await this.setQuarterFilter(e.value);
      // } else if (filterField == "Year") {
      //   this.applyServerFilter = true;
      //   await this.setYearFilter(e.value, "Year");
      // } else if (filterField == "FiscalYear") {
      //   this.applyServerFilter = true;
      //   await this.setYearFilter(e.value, "FiscalYear");
      // } else {
      //   if (
      //     filterCollection.length == 0 &&
      //     filterField != "DateGroup" &&
      //     filterField == undefined
      //   ) {
      //     await this.getDefaultValue();
      //   } else {
      //     this.showLoading(false);
      //   }
      // }
    },
    async applyFilter (type, filterCollection) {
      this.$logger.debug("createFilterArray ", type, filterCollection);
      // this.showLoading(true);
      // if (type == "clear") {
      //   this.applyServerFilter = true;
      //   await this.getDefaultValue();
      // }
      // if (this.filterDirty.isDirty == false) {
      //   this.applyServerFilter = true;
      // }
      // this.getReportData(filterCollection);
      // this.filterDirty.isDirty = false;
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });
      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" &&
          item.name !== "exportButton" &&
          item.name !== "columnChooserButton"
        );
      });
      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            visible: !this.showFilterRightContainer,
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
      );
    },
    backButtonFunction() {
      this.$router.push({
        path: "/reports/sales",
      });
    },
  },
  computed: {
    initialFilter() {
      return [["OrderStatus", "<>", "C"], 'and' , ["OrderStatus", "<>", "X"]];
    },
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "OrderStatus",
              gcType: "String",
              editorType: "dxSelectBox",
              gcLabel: "Status",
              editorOptions: {
                // itemTemplate: "date-group-items",
                editorType: "dxSelectBox",
                items: [
                  {
                    text: "Active",
                    value: "A",
                    selected: true,
                  },
                  {
                    text: "Draft",
                    value: "D",
                    selected: false,
                  },
                  {
                    text: "Picking",
                    value: "P",
                    selected: false,
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
                deferRendering: false,
                onInitialized: (e) => {
                  e.component.beginUpdate();
                  if (!this.advanceFilterModel.OrderStatus)
                    e.component.option("value", "A");
                  e.component.endUpdate();
                },
              },
            },
            {
              itemType: "group",
              caption: "",
              gcType: "group",
              colCount: 2,
              items: this.parseFormColumns([
                {
                  dataField: "DateIn",
                  gcLabel: "Date In",
                  gcType: "String",
                  editorType: "dxDateBox",
                  editorOptions: {
                    showClearButton: true,
                  },
                  cssClass: "add-icon",
                  template: "date-in-template",
                  gcRangeField: "DateInTo"
                },
                {
                  dataField: "DateInTo",
                  gcLabel: "To",
                  gcLabelVisible: false,
                  gcType: "String",
                  editorType: "dxDateBox",
                  labelLocation: "left",
                  editorOptions: {
                    showClearButton: true,
                  },
                  cssClass: "date-in-to-group",
                  template: "date-in-to-template",
                  gcRangeField: "DateIn",
                  gcFilterField: true
                },
              ]),
            },
            {
              itemType: "group",
              caption: "",
              gcType: "group",
              colCount: 2,
              items: this.parseFormColumns([
                {
                  dataField: "RequiredDate",
                  gcLabel: "Required By Date",
                  gcType: "String",
                  editorType: "dxDateBox",
                  editorOptions: {
                    showClearButton: true,
                  },
                  cssClass: "add-icon",
                  template: "date-in-template",
                  gcRangeField: "RequiredDateTo"
                },
                {
                  dataField: "RequiredDateTo",
                  gcLabel: "To",
                  gcLabelVisible: false,
                  gcType: "String",
                  editorType: "dxDateBox",
                  labelLocation: "left",
                  editorOptions: {
                    showClearButton: true,
                  },
                  cssClass: "date-in-to-group",
                  template: "date-in-to-template",
                  gcRangeField: "RequiredDate",
                  gcFilterField: true
                },
              ]),
            },
            {
              itemType: "group",
              caption: "",
              gcType: "group",
              colCount: 2,
              items: this.parseFormColumns([
                {
                  dataField: "ShipDate",
                  gcLabel: "Ship Date",
                  gcType: "String",
                  editorType: "dxDateBox",
                  editorOptions: {
                    showClearButton: true,
                  },
                  cssClass: "add-icon",
                  template: "date-in-template",
                  gcRangeField: "ShipDateTo"
                },
                {
                  dataField: "ShipDateTo",
                  gcLabel: "To",
                  gcLabelVisible: false,
                  gcType: "String",
                  editorType: "dxDateBox",
                  labelLocation: "left",
                  editorOptions: {
                    showClearButton: true,
                  },
                  cssClass: "date-in-to-group",
                  template: "date-in-to-template",
                  gcRangeField: "ShipDate",
                  gcFilterField: true
                },
              ]),
            },


            {
              dataField: "BranchCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Branch",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig("api/Branch", {
                  filter: [["Inactive", "=", "N"]],
                  sort: [{ selector: "Description", asc: true }],
                }),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
                // onInitialized: (e) => {
                //   e.component.beginUpdate();
                //   if (!this.advanceFilterModel.BranchCode)
                //     e.component.option("value", this.model.DefaultBranchCode);
                //   e.component.endUpdate();
                // },
              },
            },
            {
              dataField: "ItemCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Items",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ProductList",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description1", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description1",
                searchExpr: ["Code", "Description1"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "product-item-template",
              },
            },
            {
              dataField: "ProductCategory2Code",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Product Category 2",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ProductCategory2",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "CustomerCode",
              gcLabel: "Customer",
              gcType: "String",
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/Customer",
                  {
                    select: [
                      "Code",
                      "Name",
                      "SalesRepresentativeCode",
                      "CurrencyCode",
                    ],
                    sort: [{ selector: "Name", asc: true }],
                    top: 5,
                    filter: ["Inactive", "=", "N"],
                    key: "Code",
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Name",
                searchExpr: ["Code", "Name"],
                searchMode: "contains",
                itemTemplate: "supplier-item-template",
                searchEnabled: true,
              },
            },
            {
              dataField: "CustomerSalesRepresentativeCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Customer Rep",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/SalesRepresentative",
                  {
                    select: ["Code", "FirstName", "Surname"],
                    filter: [
                      ["Inactive", "=", "N"],
                      ["Status", "=", "A"],
                    ],
                  }
                ),
                valueExpr: "Code",
                displayExpr: function(data) {
                  if (data) return data.FirstName + " " + data.Surname;
                },
                searchMode: "contains",
                itemTemplate: "rep-item-template",
                searchEnabled: true,
              },
            },






            // {
            //   dataField: "DateIn",
            //   gcType: "Date",
            //   editorType: "DxDateBox",
            //   gcLabel: "Date In",
            //   visible: this.advanceFilterModel["DateGroup"] == "Day",
            //   editorOptions: {
            //     editorType: "DxDateBox",
            //     filterCode: "DateIn",
            //   },
            // },
           
            
          ]),
        },
      ];
    },
    columnSummary() {
      return [
        {
          id: 1,
          column: "Sales UM Order Qty",
          name: "Sales UM Order Qty",
          "summary-type": "sum",
          "value-format": this.getDecimalFormatByName("Decimal-4-2-RO").Format,
          "display-format": "{0}",
          "show-in-group-footer": false,
          "align-by-column": true,
          "show-in-column": "StockUMOrderQty",
        },
        {
          id: 2,
          column: "Sales UM Picked Qty",
          name: "Sales UM Picked Qty",
          "summary-type": "sum",
          "value-format": this.getDecimalFormatByName("Decimal-4-2-RO").Format,
          "display-format": "{0}",
          "show-in-group-footer": false,
          "align-by-column": true,
          "show-in-column": "StockUMPickedQty",
        },
        {
          id: 3,
          column: "Sales UM Back Order Qty",
          name: "Sales UM Back Order Qty",
          "summary-type": "sum",
          "value-format": this.getDecimalFormatByName("Decimal-4-2-RO").Format,
          "display-format": "{0}",
          "show-in-group-footer": false,
          "align-by-column": true,
          "show-in-column": "StockUMBackOrderQty",
        },
        {
          id: 4,
          column: "Taxable Line Total",
          name: "Taxable Line Total",
          "summary-type": "sum",
          "value-format": this.getDecimalFormatByName("Decimal-4-2C-RO").Format,
          "display-format": "{0}",
          "show-in-group-footer": false,
          "align-by-column": true,
          "show-in-column": "TaxableLineTotal",
        },
        {
          id: 5,
          column: "Taxable Back Order Line Total",
          name: "Taxable Back Order Line Total",
          "summary-type": "sum",
          "value-format": this.getDecimalFormatByName("Decimal-4-2C-RO").Format,
          "display-format": "{0}",
          "show-in-group-footer": false,
          "align-by-column": true,
          "show-in-column": "TaxableBackOrderLineTotal",
        },
      ];
    },

    columns() {
      return this.parseGridColumns("grouped-report", [
        {
          gcLabel: "Date In",
          dataField: "TxnDate",
          gcType: "Date",
          sortOrder: "asc",
          visibleIndex: "0",
        },
        {
          gcLabel: "Required By Date",
          dataField: "RequiredDate",
          gcType: "Date",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Ship Date",
          dataField: "ShipDate",
          gcType: "Date",
          sortOrder: "asc",
          sortIndex: "0",
          visibleIndex: "1",
        },
        {
          gcLabel: "Sales Order",
          dataField: "SalesOrderCode",
          gcType: "Decimal-TransactionNo",
          gcSubType: "PrimaryTransactionNo",
          groupIndex: "0",
          sortOrder: "asc",
          sortIndex: "1",
        },
        {
          gcLabel: "Sales Order Line",
          dataField: "SalesOrderLine",
          gcType: "String",
          minWidth: 50,
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Customer Group",
          dataField: "CustomerGroupName",
          gcType: "String",
          width: 220,
          // sortOrder: "asc",
          cellTemplate: "customer-group-cell-template",
          gcExport: ["CustomerGroupCode", "CustomerGroupName"],
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Customer Group Code",
          dataField: "CustomerGroupCode",
          width: 100,
          gcType: "String",
          gcSubType: "HiddenDescription",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Customer Type",
          dataField: "CustomerTypeName",
          gcType: "String",
          width: 220,
          // sortOrder: "asc",
          cellTemplate: "customer-type-cell-template",
          gcExport: ["CustomerTypeCode", "CustomerTypeName"],
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Customer Type Code",
          dataField: "CustomerTypeCode",
          width: 100,
          gcType: "String",
          gcSubType: "HiddenDescription",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Customer",
          dataField: "CustomerName",
          gcType: "String",
          minWidth: 100,
          cellTemplate: "customer-cell-template",
          gcSubType: "RelatedRecord",
          gcExport: ["CustomerCode", "CustomerName"],
          visibleIndex: "2",
        },
        {
          gcLabel: "Customer Code",
          dataField: "CustomerCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Branch",
          dataField: "BranchName",
          cellTemplate: "branch-cell-template",
          gcType: "String",
          gcSubType: "HiddenDescription",
          gcExport: ["BranchCode", "BranchName"],
          minWidth: 120,
        },
        {
          gcLabel: "Branch Code",
          dataField: "BranchCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Division",
          dataField: "DivisionName",
          gcType: "String",
          cellTemplate: "division-cell-template",
          gcExport: ["DivisionCode", "DivisionName"],
          width: 120,
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Division Code",
          dataField: "DivisionCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Item",
          dataField: "ItemName1",
          cellTemplate: "item-cell-template",
          gcType: "String",
          minWidth: 100,
          gcSubType: "RelatedRecord",
          gcExport: ["ItemCode", "ItemName1"],
          sortOrder: "asc",
          sortIndex: "3",
          visibleIndex: "2",
        },
        {
          gcLabel: "Item Code",
          dataField: "ItemCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Category 1",
          dataField: "ProdCat1Name",
          cellTemplate: "product-category-1-cell-template",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 220,
          gcExport: ["ProdCat1Code", "ProdCat1Name"],
        },
        {
          gcLabel: "Category 1 Code",
          dataField: "ProdCat1Code",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
          showInColumnChooser: false,
        },

        {
          gcLabel: "Category 2",
          dataField: "ProdCat2Name",
          cellTemplate: "product-category-2-cell-template",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 220,
          gcExport: ["ProdCat2Code", "ProdCat2Name"],
        },
        {
          gcLabel: "Category 2 Code",
          dataField: "ProdCat2Code",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
          showInColumnChooser: false,
        },

        {
          gcLabel: "Category 3",
          dataField: "ProdCat3Name",
          cellTemplate: "product-category-3-cell-template",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 220,
          gcExport: ["ProdCat3Code", "ProdCat3Name"],
        },
        {
          gcLabel: "Category 3 Code",
          dataField: "ProdCat3Code",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
          showInColumnChooser: false,
        },

        {
          gcLabel: "Category 4",
          dataField: "ProdCat4Name",
          cellTemplate: "product-category-4-cell-template",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 220,
          gcExport: ["ProdCat4Code", "ProdCat4Name"],
        },
        {
          gcLabel: "Category 4 Code",
          dataField: "ProdCat4Code",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Product Type",
          dataField: "ProdTypeName",
          gcType: "String",
          width: 220,
          cellTemplate: "product-type-cell-template",
          gcSubType: "HiddenDescription",
          gcExport: ["ProdTypeCode", "ProdTypeName"],
        },
        {
          gcLabel: "Product Type Code",
          dataField: "ProdTypeCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Order Rep",
          dataField: "OrderSalesRepName",
          width: 200,
          gcType: "String",
          cellTemplate: "sales-rep-cell-template",
          gcSubType: "HiddenDescription",
          gcExport: ["OrderSalesRepCode", "OrderSalesRepName"],
        },
        {
          gcLabel: "Order Rep Code",
          dataField: "OrderSalesRepCode",
          width: 150,
          gcType: "String",
          gcSubType: "HiddenDescription",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Customer Rep",
          dataField: "CustomerSalesRepName",
          width: 200,
          gcType: "String",
          cellTemplate: "customer-rep-cell-template",
          gcSubType: "HiddenDescription",
          gcExport: ["CustomerSalesRepCode", "CustomerSalesRepName"],
        },
        {
          gcLabel: "Customer Rep Code",
          dataField: "CustomerSalesRepCode",
          width: 150,
          gcType: "String",
          gcSubType: "HiddenDescription",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Drop",
          dataField: "DropName",
          width: 200,
          gcType: "String",
          cellTemplate: "drop-cell-template",
          gcSubType: "HiddenDescription",
          gcExport: ["DropCode", "DropName"],
        },
        {
          gcLabel: "Drop Code",
          dataField: "DropCode",
          width: 150,
          gcType: "String",
          gcSubType: "HiddenDescription",
          showInColumnChooser: false,
        },
        // {
        //   gcLabel: "Stock Group 2",
        //   dataField: "CustomerPO",
        //   width: 150,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        // },
        {
          gcLabel: "Customer PO",
          dataField: "CustomerPO",
          width: 150,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Status",
          gcType: "String",
          gcSubType: "Chip",
          dataField: "OrderStatus",
          cellTemplate: "status-cell-template",
          visibleIndex: "9",
        },
        {
          gcLabel: "Sales UM Order Qty",
          dataField: "StockUMOrderQty",
          gcType: "Decimal-4-2-RO",
          cellTemplate: "number-cell-template",
          visibleIndex: "4",
        },
        {
          gcLabel: "Sales UM Picked Qty",
          dataField: "StockUMPickedQty",
          gcType: "Decimal-4-2-RO",
          cellTemplate: "number-cell-template",
          visibleIndex: "5",
        },
        {
          gcLabel: "Sales UM Back Order Qty",
          dataField: "StockUMBackOrderQty",
          gcType: "Decimal-4-2-RO",
          cellTemplate: "number-cell-template",
          visibleIndex: "6",
        },
        {
          gcLabel: "Taxable Line Total",
          dataField: "TaxableLineTotal",
          gcType: "Decimal-4-2C-RO",
          cellTemplate: "number-cell-template",
          visibleIndex: "7",
        },
        {
          gcLabel: "Taxable Back Order Line Total",
          dataField: "TaxableBackOrderLineTotal",
          gcType: "Decimal-4-2C-RO",
          cellTemplate: "number-cell-template",
          visibleIndex: "8",
        },
        {
          gcLabel: "Line Total",
          dataField: "LineTotal",
          gcType: "Decimal-4-2C-RO",
          cellTemplate: "number-cell-template",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Stock UM Order Qty",
          dataField: "StockUMOrderQty",
          gcType: "Decimal-4-2-RO",
          cellTemplate: "number-cell-template",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Stock UM Picked Qty",
          dataField: "StockUMPickedQty",
          gcType: "Decimal-4-2-RO",
          cellTemplate: "number-cell-template",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Stock UM Back Order Qty",
          dataField: "StockUMBackOrderQty",
          gcType: "Decimal-4-2-RO",
          cellTemplate: "number-cell-template",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Order Rep Code",
          dataField: "OrderSalesRepCode",
          width: 150,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Order Rep Name",
          dataField: "OrderSalesRepName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Rep Code",
          dataField: "CustomerSalesRepCode",
          width: 150,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Rep Name",
          dataField: "CustomerSalesRepName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Group Code",
          dataField: "CustomerGroupCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Group Description",
          dataField: "CustomerGroupName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Type Code",
          dataField: "CustomerTypeCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Type Description",
          dataField: "CustomerTypeName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Code",
          dataField: "CustomerCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Name",
          dataField: "CustomerName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Branch Code",
          dataField: "BranchCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Branch Name",
          dataField: "BranchName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Division Code",
          dataField: "DivisionCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Division Name",
          dataField: "DivisionName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Item Code",
          dataField: "ItemCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Item Description",
          dataField: "ItemName1",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 1 Code",
          dataField: "ProdCat1Code",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 1 Description",
          dataField: "ProdCat1Name",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 2 Code",
          dataField: "ProdCat2Code",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 2 Description",
          dataField: "ProdCat2Name",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 3 Code",
          dataField: "ProdCat3Code",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 3 Description",
          dataField: "ProdCat3Name",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 4 Code",
          dataField: "ProdCat4Code",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 4 Description",
          dataField: "ProdCat4Name",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Product Type Code",
          dataField: "ProdTypeCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Product Type Description",
          dataField: "ProdTypeName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Drop Code",
          dataField: "DropCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Drop Name",
          dataField: "DropName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          // groupCellTemplate: "groupHeaderTemplate",
        },

        // {
        //   gcLabel: "Date",
        //   dataField: "DateGroupDisplay",
        //   gcType: "String",
        //   width: 200,
        //   //sortOrder: "desc",
        //   allowHiding: false,
        //   groupIndex: "0",
        //   cellTemplate: "dategroupdisplay-cell-template",
        //   groupCellTemplate: "group-dategroupdisplay-cell-template",
        //   // calculateGroupValue: (e) => {
        //   //   console.log('header value ', e);
        //   //   return e.DateGroupDisplay;
        //   // }
        // },
        // {
        //   gcLabel: "Customer Group",
        //   dataField: "CustomerGroupDescription",
        //   gcType: "String",
        //   width: 220,
        //   //sortOrder: "asc",
        //   cellTemplate: "customer-group-cell-template",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Customer Type",
        //   dataField: "CustomerTypeDescription",
        //   gcType: "String",
        //   minWidth: 300,
        //   cellTemplate: "customer-type-cell-template",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Customer",
        //   dataField: "CustomerName",
        //   gcType: "String",
        //   width: 220,
        //   //sortOrder: "asc",
        //   cellTemplate: "customer-cell-template",
        //   groupIndex: "1",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Branch",
        //   dataField: "BranchDescription",
        //   gcType: "String",
        //   width: 220,
        //   cellTemplate: "branch-cell-template",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Category 1",
        //   dataField: "ProductCategory1Description",
        //   gcType: "String",
        //   width: 220,
        //   cellTemplate: "category-1-cell-template",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Category 2",
        //   dataField: "ProductCategory2Description",
        //   gcType: "String",
        //   width: 220,
        //   //sortOrder: "asc",
        //   cellTemplate: "category-2-cell-template",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Category 3",
        //   dataField: "ProductCategory3Description",
        //   gcType: "String",
        //   width: 220,
        //   cellTemplate: "category-3-cell-template",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Category 4",
        //   dataField: "ProductCategory4Description",
        //   gcType: "String",
        //   width: 220,
        //   cellTemplate: "category-4-cell-template",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Product Type",
        //   dataField: "ProductTypeDescription",
        //   gcType: "String",
        //   width: 220,
        //   cellTemplate: "product-type-cell-template",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Product Size",
        //   dataField: "ProductSizeDescription",
        //   gcType: "String",
        //   width: 220,
        //   cellTemplate: "product-size-cell-template",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Order Rep",
        //   dataField: "SalesRepresentativeCode",
        //   width: 200,
        //   gcType: "String",
        //   cellTemplate: "sales-rep-cell-template",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Customer Rep",
        //   dataField: "CustomerSalesRepresentativeCode",
        //   width: 200,
        //   gcType: "String",
        //   cellTemplate: "customer-rep-cell-template",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Item",
        //   dataField: "ItemDescription1",
        //   gcType: "String",
        //   width: 220,
        //   //sortOrder: "asc",
        //   cellTemplate: "item-cell-template",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Quantity",
        //   dataField: "ItemQty",
        //   gcType: "Decimal-4-2-RO",
        //   cellTemplate: "number-cell-template",
        // },
        // {
        //   gcDynamicLabel: this.getLabelWithCurrencyCode('Ex Tax'),
        //   dataField: "SalesExTax",
        //   gcType: "Decimal-4-2C-RO",
        //   allowResizing: false,
        //   cellTemplate: "number-cell-template",
        // },
        // {
        //   gcDynamicLabel: this.getLabelWithCurrencyCode('Cost'),
        //   dataField: "TotalCost",
        //   gcType: "Decimal-4-2C-RO",
        //   allowResizing: false,
        //   cellTemplate: "number-cell-template",
        // },
        // {
        //   gcDynamicLabel: this.getLabelWithCurrencyCode('GP'),
        //   dataField: "GrossProfitVal",
        //   gcType: "Decimal-4-2C-RO",
        //   allowResizing: false,
        //   cellTemplate: "number-cell-template",
        // },
        // {
        //   gcLabel: "GP",
        //   dataField: "GrossProfitPcnt",
        //   gcType: "Decimal-4-2P",
        //   allowResizing: false,
        //   cellTemplate: "number-cell-template",
        // },
        // {
        //   gcLabel: "Order Rep Code",
        //   dataField: "SalesRepresentativeCode",
        //   width: 150,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Order Rep Name",
        //   dataField: "SalesRepresentativeFullName",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Customer Rep Code",
        //   dataField: "CustomerSalesRepresentativeCode",
        //   width: 150,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Customer Rep Name",
        //   dataField: "CustomerSalesRepresentativeFullName",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Customer Group Code",
        //   dataField: "CustomerGroupCode",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Customer Group Description",
        //   dataField: "CustomerGroupDescription",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Customer Type Code",
        //   dataField: "CustomerTypeCode",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Customer Type Description",
        //   dataField: "CustomerTypeDescription",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Customer Code",
        //   dataField: "CustomerCode",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Customer Name",
        //   dataField: "CustomerName",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Branch Code",
        //   dataField: "BranchCode",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Branch Name",
        //   dataField: "BranchDescription",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Category 1 Code",
        //   dataField: "ProductCategory1Code",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Category 1 Description",
        //   dataField: "ProductCategory1Description",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Category 2 Code",
        //   dataField: "ProductCategory2Code",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Category 2 Description",
        //   dataField: "ProductCategory2Description",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Category 3 Code",
        //   dataField: "ProductCategory3Code",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Category 3 Description",
        //   dataField: "ProductCategory3Description",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Category 4 Code",
        //   dataField: "ProductCategory4Code",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Category 4 Description",
        //   dataField: "ProductCategory4Description",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Product Type Code",
        //   dataField: "ProductTypeCode",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Product Type Description",
        //   dataField: "ProductTypeDescription",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Product Size Code",
        //   dataField: "ProductSizeCode",
        //   width: 150,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Product Size Description",
        //   dataField: "ProductSizeDescription",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Item Code",
        //   dataField: "ItemCode",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "Item Description",
        //   dataField: "ItemDescription1",
        //   width: 200,
        //   gcType: "String",
        //   gcSubType: "HiddenDescription",
        //   groupCellTemplate: "groupHeaderTemplate",
        // },
        // {
        //   gcLabel: "",
        //   dataField: "",
        //   width: 5,
        //   minWidth: 5,
        //   gcType: "String",
        //   allowResizing: false,
        //   columnMinWidth: 5,
        //   fixed: true,
        //   fixedPosition: "right",
        //   allowExporting: false,
        //   allowGrouping: false,
        //   allowHiding: false,
        //   showInColumnChooser: false,
        // },
      ]);
    },
  },
};
</script>
